// routerServiceV6.ts
// Service khusus untuk RouterOS v6
import api from './api';

const routerServiceV6 = {
  getRouterDetails: (id: string) => api.get(`/routers/${id}/details`),
  getRouterResources: (id: string) => api.get(`/routers/${id}/resources`),
  getPPPActiveConnections: (id: string) => api.get(`/routers/${id}/ppp-connections`),
  // Tambahkan endpoint lain khusus v6 jika perlu
};

export default routerServiceV6;
